/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as MentorRouteImport } from './routes/mentor'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HomeRouteImport } from './routes/home'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ParentIndexRouteImport } from './routes/parent.index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications.index'
import { Route as MaterialsIndexRouteImport } from './routes/materials.index'
import { Route as FlashcardsIndexRouteImport } from './routes/flashcards.index'
import { Route as FamilyIndexRouteImport } from './routes/family.index'
import { Route as CatalogIndexRouteImport } from './routes/catalog/index'
import { Route as AssignmentsIndexRouteImport } from './routes/assignments.index'
import { Route as ResultAttemptIdRouteImport } from './routes/result.$attemptId'
import { Route as QuizQuizIdRouteImport } from './routes/quiz.$quizId'
import { Route as ParentResultsRouteImport } from './routes/parent.results'
import { Route as ParentProfileRouteImport } from './routes/parent.profile'
import { Route as ParentAttendanceRouteImport } from './routes/parent.attendance'
import { Route as ParentAnnouncementsRouteImport } from './routes/parent.announcements'
import { Route as FlashcardsDeckIdRouteImport } from './routes/flashcards.$deckId'
import { Route as CourseCourseIdRouteImport } from './routes/course.$courseId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressRoute = ProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const MentorRoute = MentorRouteImport.update({
  id: '/mentor',
  path: '/mentor',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentIndexRoute = ParentIndexRouteImport.update({
  id: '/parent/',
  path: '/parent/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsIndexRoute = MaterialsIndexRouteImport.update({
  id: '/materials/',
  path: '/materials/',
  getParentRoute: () => rootRouteImport,
} as any)
const FlashcardsIndexRoute = FlashcardsIndexRouteImport.update({
  id: '/flashcards/',
  path: '/flashcards/',
  getParentRoute: () => rootRouteImport,
} as any)
const FamilyIndexRoute = FamilyIndexRouteImport.update({
  id: '/family/',
  path: '/family/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignmentsIndexRoute = AssignmentsIndexRouteImport.update({
  id: '/assignments/',
  path: '/assignments/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultAttemptIdRoute = ResultAttemptIdRouteImport.update({
  id: '/result/$attemptId',
  path: '/result/$attemptId',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizQuizIdRoute = QuizQuizIdRouteImport.update({
  id: '/quiz/$quizId',
  path: '/quiz/$quizId',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentResultsRoute = ParentResultsRouteImport.update({
  id: '/parent/results',
  path: '/parent/results',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentProfileRoute = ParentProfileRouteImport.update({
  id: '/parent/profile',
  path: '/parent/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentAttendanceRoute = ParentAttendanceRouteImport.update({
  id: '/parent/attendance',
  path: '/parent/attendance',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentAnnouncementsRoute = ParentAnnouncementsRouteImport.update({
  id: '/parent/announcements',
  path: '/parent/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const FlashcardsDeckIdRoute = FlashcardsDeckIdRouteImport.update({
  id: '/flashcards/$deckId',
  path: '/flashcards/$deckId',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseCourseIdRoute = CourseCourseIdRouteImport.update({
  id: '/course/$courseId',
  path: '/course/$courseId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/mentor': typeof MentorRoute
  '/profile': typeof ProfileRoute
  '/progress': typeof ProgressRoute
  '/results': typeof ResultsRoute
  '/signup': typeof SignupRoute
  '/course/$courseId': typeof CourseCourseIdRoute
  '/flashcards/$deckId': typeof FlashcardsDeckIdRoute
  '/parent/announcements': typeof ParentAnnouncementsRoute
  '/parent/attendance': typeof ParentAttendanceRoute
  '/parent/profile': typeof ParentProfileRoute
  '/parent/results': typeof ParentResultsRoute
  '/quiz/$quizId': typeof QuizQuizIdRoute
  '/result/$attemptId': typeof ResultAttemptIdRoute
  '/assignments/': typeof AssignmentsIndexRoute
  '/catalog/': typeof CatalogIndexRoute
  '/family/': typeof FamilyIndexRoute
  '/flashcards/': typeof FlashcardsIndexRoute
  '/materials/': typeof MaterialsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/parent/': typeof ParentIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/mentor': typeof MentorRoute
  '/profile': typeof ProfileRoute
  '/progress': typeof ProgressRoute
  '/results': typeof ResultsRoute
  '/signup': typeof SignupRoute
  '/course/$courseId': typeof CourseCourseIdRoute
  '/flashcards/$deckId': typeof FlashcardsDeckIdRoute
  '/parent/announcements': typeof ParentAnnouncementsRoute
  '/parent/attendance': typeof ParentAttendanceRoute
  '/parent/profile': typeof ParentProfileRoute
  '/parent/results': typeof ParentResultsRoute
  '/quiz/$quizId': typeof QuizQuizIdRoute
  '/result/$attemptId': typeof ResultAttemptIdRoute
  '/assignments': typeof AssignmentsIndexRoute
  '/catalog': typeof CatalogIndexRoute
  '/family': typeof FamilyIndexRoute
  '/flashcards': typeof FlashcardsIndexRoute
  '/materials': typeof MaterialsIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/parent': typeof ParentIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/mentor': typeof MentorRoute
  '/profile': typeof ProfileRoute
  '/progress': typeof ProgressRoute
  '/results': typeof ResultsRoute
  '/signup': typeof SignupRoute
  '/course/$courseId': typeof CourseCourseIdRoute
  '/flashcards/$deckId': typeof FlashcardsDeckIdRoute
  '/parent/announcements': typeof ParentAnnouncementsRoute
  '/parent/attendance': typeof ParentAttendanceRoute
  '/parent/profile': typeof ParentProfileRoute
  '/parent/results': typeof ParentResultsRoute
  '/quiz/$quizId': typeof QuizQuizIdRoute
  '/result/$attemptId': typeof ResultAttemptIdRoute
  '/assignments/': typeof AssignmentsIndexRoute
  '/catalog/': typeof CatalogIndexRoute
  '/family/': typeof FamilyIndexRoute
  '/flashcards/': typeof FlashcardsIndexRoute
  '/materials/': typeof MaterialsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/parent/': typeof ParentIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/login'
    | '/mentor'
    | '/profile'
    | '/progress'
    | '/results'
    | '/signup'
    | '/course/$courseId'
    | '/flashcards/$deckId'
    | '/parent/announcements'
    | '/parent/attendance'
    | '/parent/profile'
    | '/parent/results'
    | '/quiz/$quizId'
    | '/result/$attemptId'
    | '/assignments/'
    | '/catalog/'
    | '/family/'
    | '/flashcards/'
    | '/materials/'
    | '/notifications/'
    | '/parent/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/home'
    | '/login'
    | '/mentor'
    | '/profile'
    | '/progress'
    | '/results'
    | '/signup'
    | '/course/$courseId'
    | '/flashcards/$deckId'
    | '/parent/announcements'
    | '/parent/attendance'
    | '/parent/profile'
    | '/parent/results'
    | '/quiz/$quizId'
    | '/result/$attemptId'
    | '/assignments'
    | '/catalog'
    | '/family'
    | '/flashcards'
    | '/materials'
    | '/notifications'
    | '/parent'
  id:
    | '__root__'
    | '/'
    | '/home'
    | '/login'
    | '/mentor'
    | '/profile'
    | '/progress'
    | '/results'
    | '/signup'
    | '/course/$courseId'
    | '/flashcards/$deckId'
    | '/parent/announcements'
    | '/parent/attendance'
    | '/parent/profile'
    | '/parent/results'
    | '/quiz/$quizId'
    | '/result/$attemptId'
    | '/assignments/'
    | '/catalog/'
    | '/family/'
    | '/flashcards/'
    | '/materials/'
    | '/notifications/'
    | '/parent/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HomeRoute: typeof HomeRoute
  LoginRoute: typeof LoginRoute
  MentorRoute: typeof MentorRoute
  ProfileRoute: typeof ProfileRoute
  ProgressRoute: typeof ProgressRoute
  ResultsRoute: typeof ResultsRoute
  SignupRoute: typeof SignupRoute
  CourseCourseIdRoute: typeof CourseCourseIdRoute
  FlashcardsDeckIdRoute: typeof FlashcardsDeckIdRoute
  ParentAnnouncementsRoute: typeof ParentAnnouncementsRoute
  ParentAttendanceRoute: typeof ParentAttendanceRoute
  ParentProfileRoute: typeof ParentProfileRoute
  ParentResultsRoute: typeof ParentResultsRoute
  QuizQuizIdRoute: typeof QuizQuizIdRoute
  ResultAttemptIdRoute: typeof ResultAttemptIdRoute
  AssignmentsIndexRoute: typeof AssignmentsIndexRoute
  CatalogIndexRoute: typeof CatalogIndexRoute
  FamilyIndexRoute: typeof FamilyIndexRoute
  FlashcardsIndexRoute: typeof FlashcardsIndexRoute
  MaterialsIndexRoute: typeof MaterialsIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  ParentIndexRoute: typeof ParentIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progress': {
      id: '/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof ProgressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mentor': {
      id: '/mentor'
      path: '/mentor'
      fullPath: '/mentor'
      preLoaderRoute: typeof MentorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/': {
      id: '/parent/'
      path: '/parent'
      fullPath: '/parent/'
      preLoaderRoute: typeof ParentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/': {
      id: '/materials/'
      path: '/materials'
      fullPath: '/materials/'
      preLoaderRoute: typeof MaterialsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flashcards/': {
      id: '/flashcards/'
      path: '/flashcards'
      fullPath: '/flashcards/'
      preLoaderRoute: typeof FlashcardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/family/': {
      id: '/family/'
      path: '/family'
      fullPath: '/family/'
      preLoaderRoute: typeof FamilyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignments/': {
      id: '/assignments/'
      path: '/assignments'
      fullPath: '/assignments/'
      preLoaderRoute: typeof AssignmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/result/$attemptId': {
      id: '/result/$attemptId'
      path: '/result/$attemptId'
      fullPath: '/result/$attemptId'
      preLoaderRoute: typeof ResultAttemptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quiz/$quizId': {
      id: '/quiz/$quizId'
      path: '/quiz/$quizId'
      fullPath: '/quiz/$quizId'
      preLoaderRoute: typeof QuizQuizIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/results': {
      id: '/parent/results'
      path: '/parent/results'
      fullPath: '/parent/results'
      preLoaderRoute: typeof ParentResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/profile': {
      id: '/parent/profile'
      path: '/parent/profile'
      fullPath: '/parent/profile'
      preLoaderRoute: typeof ParentProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/attendance': {
      id: '/parent/attendance'
      path: '/parent/attendance'
      fullPath: '/parent/attendance'
      preLoaderRoute: typeof ParentAttendanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/announcements': {
      id: '/parent/announcements'
      path: '/parent/announcements'
      fullPath: '/parent/announcements'
      preLoaderRoute: typeof ParentAnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flashcards/$deckId': {
      id: '/flashcards/$deckId'
      path: '/flashcards/$deckId'
      fullPath: '/flashcards/$deckId'
      preLoaderRoute: typeof FlashcardsDeckIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course/$courseId': {
      id: '/course/$courseId'
      path: '/course/$courseId'
      fullPath: '/course/$courseId'
      preLoaderRoute: typeof CourseCourseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HomeRoute: HomeRoute,
  LoginRoute: LoginRoute,
  MentorRoute: MentorRoute,
  ProfileRoute: ProfileRoute,
  ProgressRoute: ProgressRoute,
  ResultsRoute: ResultsRoute,
  SignupRoute: SignupRoute,
  CourseCourseIdRoute: CourseCourseIdRoute,
  FlashcardsDeckIdRoute: FlashcardsDeckIdRoute,
  ParentAnnouncementsRoute: ParentAnnouncementsRoute,
  ParentAttendanceRoute: ParentAttendanceRoute,
  ParentProfileRoute: ParentProfileRoute,
  ParentResultsRoute: ParentResultsRoute,
  QuizQuizIdRoute: QuizQuizIdRoute,
  ResultAttemptIdRoute: ResultAttemptIdRoute,
  AssignmentsIndexRoute: AssignmentsIndexRoute,
  CatalogIndexRoute: CatalogIndexRoute,
  FamilyIndexRoute: FamilyIndexRoute,
  FlashcardsIndexRoute: FlashcardsIndexRoute,
  MaterialsIndexRoute: MaterialsIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  ParentIndexRoute: ParentIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
